var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tips"},[_vm._v(" 当前为用户ID: "+_vm._s(_vm.stuId)+" "),(_vm.isTestUser)?_c('span',[_vm._v("(测试)")]):_vm._e(),_vm._v(" 购买模拟预览页面，无法实际支付，支付请使用购买链接！ ")])}
var staticRenderFns = []

export { render, staticRenderFns }